export default {"src":"/_next/static/media/linkedin.8313eb0e.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};